import { takeLatest, put, call } from 'redux-saga/effects';
import { history } from '@commons';
import { createCentroCustoCadastro, updateCentroCustoCadastro } from '../service';
import {
  CREATE_CENTRO_CUSTO_CADASTRO,
  CREATE_CENTRO_CUSTO_CADASTRO_PENDING,
  CREATE_CENTRO_CUSTO_CADASTRO_SUCCESS,
  CREATE_CENTRO_CUSTO_CADASTRO_FAILURE,
} from '@handler';
import { AlertSuccess, AlertError } from '@components/common/AlertToast';
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateCentroCustoCadastro(action) {
  yield put({ type: CREATE_CENTRO_CUSTO_CADASTRO_PENDING });

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createCentroCustoCadastro, action.data);
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CENTRO_CUSTO_CRIAR);
    } else {
      yield call(updateCentroCustoCadastro,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.CENTRO_CUSTO_EDITAR);
    }

    yield put({ type: CREATE_CENTRO_CUSTO_CADASTRO_SUCCESS, registro: action.data });

    if (!action.isCadastroRapido) {
      history.push('/financeiro/centroCustoCadastro');
    }

    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_CENTRO_CUSTO_CADASTRO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }

}

export default function* watchCreateCentroCustoCadastro() {
  yield takeLatest(CREATE_CENTRO_CUSTO_CADASTRO, sagaCreateCentroCustoCadastro);
}
